export default __webpack_public_path__ + "static/media/back-button.53ed2ee8.svg";